<template>
  <div class="page-wraper">
    <div class="main">
      <van-row gutter="10">
        <van-col span="12" v-for="item in list" :key="item.RoomId">
          <div class="item" @click="onItemClick(item)">
            <div class="state-wraper">
              <span
                class="state"
                :style="{ background: statusColor[item.Status] }"
              >
                {{ statusText[item.Status] }}
              </span>
            </div>
            <p class="title">
              <b>{{ item.Name }}</b
              >（{{ item.PersonNum }}人）
            </p>
            <p class="address">
              位置：{{ item.BuildingName }} {{ item.FloorName }}
            </p>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import classRoomApi from "@/api/classRoom";

export default {
  data() {
    return {
      statusColor: {
        "-1": "#d20001",
        0: "#51c2e2",
        1: "rgb(255, 198, 57)"
      },
      statusText: {
        "-1": "不可使用",
        0: "空闲",
        1: "已占用"
      },
      list: []
    };
  },
  created() {
    const query = this.$route.query;
    if (query.MeetingRoomTypeId && query.MeetingRoomSubTypeId) {
      this.fetchOccupancyDetail(query);
    }
  },
  methods: {
    fetchOccupancyDetail(param) {
      param.FilterAccess = true;
      classRoomApi.QueryMeetingRoomOccupancyDetail(param).then(res => {
        this.list = res.Data;
      });
    },
    onItemClick(item) {
      this.$router.push({
        name: "classroomUsageDetail",
        query: {
          BuildingCode: item.BuildingCode,
          FloorCode: item.FloorCode,
          RoomId: item.RoomId
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  padding: 7px 15px;
  .item {
    border-radius: 4px;
    padding: 5px 10px 10px;
    background-color: rgb(248, 248, 248);
    margin-bottom: 10px;
    position: relative;
    .state-wraper {
      text-align: right;
    }
    .state {
      border-radius: 4px;
      font-size: 12px;
      color: #fff;
      padding: 1px 10px;
      display: inline-block;
    }

    .title {
      margin-bottom: 10px;
      font-size: 14px;
    }
    .address {
      font-size: 14px;
    }
  }
}
</style>
